import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext();

export function AppProvider({ children }) {
  const [apiKey, setApiKey] = useState('');
  const [apiKeySet, setApiKeySet] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [reviewLoading, setReviewLoading] = useState(false);
  const [error, setError] = useState(null);
  const [papers, setPapers] = useState([]);
  const [selectedPapers, setSelectedPapers] = useState([]);
  const [generatedReview, setGeneratedReview] = useState('');
  const [parameters, setParameters] = useState({
    modelName: 'openai/gpt-4o-mini',
    temperature: 0.7,
    maxTokens: 1000,
    llmRerank: 'True'
  });

  return (
    <AppContext.Provider value={{
      apiKey,
      setApiKey,
      apiKeySet,
      setApiKeySet,
      searchLoading,
      setSearchLoading,
      reviewLoading,
      setReviewLoading,
      error,
      setError,
      papers,
      setPapers,
      selectedPapers,
      setSelectedPapers,
      generatedReview,
      setGeneratedReview,
      parameters,
      setParameters
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
} 